import * as React from 'react';
import { connect } from 'react-redux';
import '../css/SuperUserPageView.css';
import { TooltipCont } from '../../../infrastructure/tooltips';
import { getScrollbarWidth } from '../../../lib/helpers';
import { ITechSheet, ISeedCategory } from '../../../infrastructure/interfaces'
import { getTechSheets, getSeedCategories, toggleTechSheetPublish, createTechSheets} from '../../../actions/actions'
import HeaderBar from '../../HeaderBar/HeaderBar';
import TechSheetCreatorModal from '../../Modals/TechSheetCreatorModal/TechSheetCreatorModal'
import DeleteConfirmModal from '../../Modals/DeleteConfirmModal';
import { deleteAllTechSheets } from '../../../actions/actions'
import { FilterMenu } from 'src/components/FilterMenu';
import PreviewTechSheetModal from '../../Modals/PreviewTechSheetModal/PreviewTechSheetModal'

export interface IManageFullPageCatalogImagesProps {
  techSheets?: ITechSheet[];
  seedCategories?: ISeedCategory[];
  toggleTechSheetPublish(techSheet: ITechSheet): void;
  createTechSheets(techSheetName: string[], seedCategory: ISeedCategory, formData: FormData[]): void;
  getTechSheets(): void;
  getSeedCategories(): void;
  onCreate(): void;
  deleteAllTechSheets(): void;
}

export interface IManageFullPageCatalogImagesState {
  selectedTechSheet?: ITechSheet;
  showTechSheetCreatorModal: Boolean;
  showPreviewModal: boolean;
  showDeleteSheetModal: boolean;
  searchFilter: string;
  categoryFilter: string;
}

const mapStateToProps = (state: any) => {
  return {
    techSheets: state.techSheetList.sort((a: ITechSheet, b: ITechSheet) => a.name.localeCompare(b.name)),
    seedCategories: state.seedCategoryList
  };
};

const mapDispatchToProps = (dispatch: any): any => {
  return {
    getTechSheets: () => {
      dispatch(getTechSheets());
    },
    getSeedCategories: () => {
      dispatch(getSeedCategories());
    },
    toggleTechSheetPublish: (techSheet: ITechSheet) => {
      dispatch(toggleTechSheetPublish(techSheet));
    },
    createTechSheets: (techSheetName: [string], seedCategory: ISeedCategory, formData: [FormData]) => {
      dispatch(createTechSheets(techSheetName, seedCategory, formData));
    },
    deleteAllTechSheets: () => {
      dispatch(deleteAllTechSheets());
    },
  };
};

@(connect(mapStateToProps, mapDispatchToProps) as any)
export default class ManageTechSheetsTable extends React.Component<IManageFullPageCatalogImagesProps, IManageFullPageCatalogImagesState> {
  shouldUpdate = false;
  tableRow: HTMLElement;
  constructor(props: IManageFullPageCatalogImagesProps) {
    super(props);
    this.state = {
      showTechSheetCreatorModal: false,
      showPreviewModal: false,
      showDeleteSheetModal: false,
      searchFilter: '',
      categoryFilter: '',
    };

    // Bind methods
    this.closeModals = this.closeModals.bind(this)
    this.createTechSheets = this.createTechSheets.bind(this)
  }

  componentWillReceiveProps(nextProps: any) {
    this.shouldUpdate = true;
  }

  componentDidMount() {
    this.props.getTechSheets();
    this.props.getSeedCategories();
  }

  onCreateTechSheet() {
    this.shouldUpdate = true;
    this.setState({
        showTechSheetCreatorModal: true,
        showDeleteSheetModal: false,
        selectedTechSheet: undefined,
    });
  }

  onDeleteTechSheetsRequest() {
    this.setState({
      showTechSheetCreatorModal: false,
      showDeleteSheetModal: true,
      selectedTechSheet: undefined,
    });
  }

  deleteAllTechSheets() {
    this.props.deleteAllTechSheets();
  }

  ontoggleTechSheetPublish(techSheet: ITechSheet) {
    if( techSheet ) {
      this.toggleTechSheetPublish(techSheet);
    }
  }

  onTechSheetPreview(techSheet: ITechSheet) {
    if( techSheet ) {
      this.setState({
        selectedTechSheet: techSheet,
        showPreviewModal: true,
      });
    }
  }

  toggleTechSheetPublish(techSheet: ITechSheet) {
    this.props.toggleTechSheetPublish(techSheet)
  }

  createTechSheets(techSheetName: string[], seedCategory: ISeedCategory, formData: FormData[]) {
    this.props.createTechSheets(techSheetName, seedCategory, formData)
  }

  filterTechSheets = (products: any[]) => {
    const searchFilter = this.state.searchFilter.toUpperCase();
    const searchfilteredSheets = products.filter((p) =>
      searchFilter ? (p.name.toUpperCase().indexOf(searchFilter) > -1) : true
    );
    const filteredSheets = searchfilteredSheets.filter((p) => {
      const includedInCategoryFilter = ((this.state.categoryFilter.length == 0) || (this.state.categoryFilter == (p.category && p.category.name)));
      return includedInCategoryFilter;
      }
  );

    return filteredSheets;
  };

  onSearchFilterChange = (e: any) => {
    this.setState({
      searchFilter: e.target.value,
    });
    // keyCode === 8 is a 'backspace' event
    e.keyCode === 8 && !e.target.value
      ? (this.shouldUpdate = true)
      : (this.shouldUpdate = false);
  };

  closeModals() {
    this.setState({
      showTechSheetCreatorModal: false,
      showPreviewModal: false,
      showDeleteSheetModal: false,
      selectedTechSheet: undefined
    });
  }

  render() {

    const {
      techSheets,
      seedCategories,
    } = this.props;

    if (this.state.showPreviewModal && (this.state.selectedTechSheet != undefined)) {
      return (
        <PreviewTechSheetModal
          show={this.state.showPreviewModal}
          techSheet={this.state.selectedTechSheet}
          onClose={() => this.setState({ showPreviewModal: false })}
        />
      );
    }
    var nonNullTechSheets = techSheets ? techSheets : [];
    var nonNullSeedCategories = seedCategories ? seedCategories : [];
    const filteredSheets = this.filterTechSheets(nonNullTechSheets);

    return (
      <div className="root-container">
        <HeaderBar />
        <div className="inner-su-container">
          <div className="manage-items-row-offsetRight-tech-sheets">

          <div className="productTable-search">
            <input
              type="text"
              onKeyUp={this.onSearchFilterChange}
              placeholder="Search Tech Sheets"
            />
          </div>

            <div className="in-row-text-container">
              Manage Tech Sheets
            </div>
            <div className="in-row-button-container">
              <button
                className="btn primary-green large"
                onClick={() => this.onCreateTechSheet()}
                title={TooltipCont.CREATE_PRODUCT}
              >
                Upload Tech Sheets
              </button>
              <button
                      className="btn primary-red large"
                      onClick={() => this.onDeleteTechSheetsRequest()}
                      title={TooltipCont.DELETE}
                      disabled={false}
                    >
                      Delete All
                    </button>
            </div>
          </div>
          <table className="table-scrollableSU documents-table">
            <thead style={{ paddingRight: getScrollbarWidth() }}>
              <tr>
                <th>Name</th>
                <th>
                <FilterMenu
                  title="Seed Category"
                  options={nonNullSeedCategories.map((p) => {
                    return { title: p.name };
                  })}
                  onFilter={(filterApplied: string) => {
                      this.shouldUpdate = true;
                      this.setState({ categoryFilter: filterApplied });
                  }}
                />
              </th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody className="document-table-body">
              {filteredSheets.map((t: ITechSheet) =>
                <tr key={t.id} ref={tr => this.tableRow = tr!}>
                  <td>
                      {t.name}
                  </td>
                  <td>
                    {t.category.name}
                  </td>
                  <td>
                    <div className="button-wrapper">
                      <button
                        className="btn primary-blue"
                        onClick={() => this.ontoggleTechSheetPublish(t)}
                        title={TooltipCont.PUBLISH}
                        disabled={false}
                      >
                        {t.published ? "Unpublish" : "Publish"}
                      </button>

                      <button
                        className="btn primary-blue"
                        onClick={() => this.onTechSheetPreview(t)}
                        title={TooltipCont.PREVIEW}
                        disabled={false}
                      >
                        Preview
                      </button>
                    </div>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>

        <TechSheetCreatorModal
          show={this.state.showTechSheetCreatorModal}
          onClose={this.closeModals}
          onSubmit={(techSheetName: string[], seedCategory: ISeedCategory, formData: FormData[]) => {
            this.createTechSheets(techSheetName, seedCategory, formData);
            this.closeModals();
          }}
          seedCategories={this.props.seedCategories}
        />

        <DeleteConfirmModal
          show={this.state.showDeleteSheetModal}
          onClose={() => this.closeModals()}
          onSave={() => {
              if(nonNullTechSheets.length > 0) {
                this.deleteAllTechSheets();
              }
              this.closeModals();
          }}
          title={'Delete All Tech Sheets? THIS IS A DESTRUCTIVE OPERATION, AND CANNOT BE REVERSED'}
        />
      </div>);
  }
}



// WEBPACK FOOTER //
// ./src/components/SuperUser/components/ManageTechSheets.tsx